module.exports = __webpack_public_path__ + "img/lilbosh_meil_no.ad9412a5.png";